import { createFileRoute, redirect } from "@tanstack/react-router"
import { DemoSettingsPage } from "~/components/settings/DemoCategoryMappingCard"
import { isDemo, isLocal } from "~/utils/environment"

export const Route = createFileRoute("/_auth/settings/_layout/_internal/demo")({
  beforeLoad: () => {
    if (!isDemo() && !isLocal()) throw redirect({ to: "/settings", replace: true })
  },
  component: DemoSettingsPage,
})
